/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RequestCounts = {
  total: number;
  completed: number;
  failed: number;
};

/** @internal */
export const RequestCounts$inboundSchema: z.ZodType<
  RequestCounts,
  z.ZodTypeDef,
  unknown
> = z.object({
  total: z.number().int(),
  completed: z.number().int(),
  failed: z.number().int(),
});
/** @internal */
export type RequestCounts$Outbound = {
  total: number;
  completed: number;
  failed: number;
};

/** @internal */
export const RequestCounts$outboundSchema: z.ZodType<
  RequestCounts$Outbound,
  z.ZodTypeDef,
  RequestCounts
> = z.object({
  total: z.number().int(),
  completed: z.number().int(),
  failed: z.number().int(),
});

export function requestCountsToJSON(requestCounts: RequestCounts): string {
  return JSON.stringify(RequestCounts$outboundSchema.parse(requestCounts));
}
export function requestCountsFromJSON(
  jsonString: string,
): SafeParseResult<RequestCounts, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RequestCounts$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RequestCounts' from JSON`,
  );
}
